export default __webpack_public_path__ + "static/media/tn-ventas-03-EN.b3ee1674.jpg";